export var STORE_CONSTANTS;
(function (STORE_CONSTANTS) {
    STORE_CONSTANTS["DARK_MODE_KEY"] = "darkMode";
})(STORE_CONSTANTS || (STORE_CONSTANTS = {}));
export const InitialMetaData = { page: 1, total: 0 };
